import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { IStatusScore, ICapabilityViewSS, ISubCategorySS, ICapabilitySS, IQuestionSS } from 'types/ScorePage';
import { RowModel, TreeState, TreeTable } from 'cp-react-tree-table';
import { useDispatch } from 'react-redux';
import { saveCandidateLastActivity } from 'store/evaluationPlatform';
import { useHistory } from 'react-router';
import { camelize } from 'utilities';
import { Row } from 'react-bootstrap';

const StyledContainer = styled.div`
  width: 100%;
  height: 210px;
  background: #fff;
  font-size: 14px;
  .cp_tree-table {
    width: 100% !important;
    min-height: 300px;
    font-size: 12px;
    color: #040402;
    font-family: -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;
  }
  .cp_tree-table_header {
    color: rgba(55, 53, 47, 0.6);
  }
  .cp_tree-table .cp_tree-table_header-cell>.t-right {
    width: 100%;
  }
  .cp_tree-table_cell{
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  /* Cells */
  .cp_tree-table .cp_tree-table_cell,
  .cp_tree-table .cp_tree-table_header-cell {
    >a, .without-children>a{
      cursor: pointer;
    }
    display: flex;
    align-items: center;
    padding: 0 10px;
  }
  .cp_tree-table .cp_tree-table_cell>input {
    font-size: 14px;    outline: none;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    box-shadow: inset 0 0 0 1px rgba(55, 53, 47, 0.16);
    border: 1px solid transparent;
  }
  .cp_tree-table .cp_tree-table_cell>input:hover {
    box-shadow: inset 0 0 0 1px #0f55eb;
  }

  .cp_tree-table .cp_tree-table_cell>input:focus {
    background: #edf6fc;
    box-shadow: inset 0 0 0 1px #0f55eb;
  }
  .cp_tree-table .cp_tree-table_cell .toggle-button {
    position: relative;
    display: inline-block;
    border: none;
    vertical-align: middle;
    padding: 0 5px 0 0;
    margin: 0;
    cursor: pointer;
    background-color: transparent;
    outline: none;
  }
  .cp_tree-table .cp_tree-table_cell .toggle-button::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-style: solid;
    border-width: 2px;
    transform: rotate(45deg);
    border-color: #040402 #040402 transparent transparent;
    vertical-align: middle;
    margin-bottom: 5px;
    margin-right: 5px;
  }
  .cp_tree-table .cp_tree-table_cell .toggle-button.open::before{
    transform: rotate(135deg);
  }
  .cp_tree-table .cp_tree-table_cell .toggle-button+span {
    vertical-align: middle;
  }
  .cp_tree-table .cp_tree-table_cell>.with-children>span {
    font-weight: 600;
  }
  .cp_tree-table .cp_tree-table_cell>.data-cell {
    width: 50%;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: right;
  }
  .hover-capability {
    display: none;
  }
  .without-children{
    width: 100%;
  }
  .without-children:hover .hover-capability {
    margin-left: 5px;
    display: inline;
  }
  .cp_tree-table .cp_tree-table_cell>.expenses-cell {
    font-family: 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', Menlo, Courier, monospace;
    font-weight: 400;
    width: 100%;
    padding-right: 10px;
  }
  .controls {
    width: 100%;
  }
  .capitalize{
    text-transform: capitalize;
  }
  .cp_tree-table_header-cell{
    padding: 0px !important;
  }
  .controls{
    img{
      height: 25px;
      width: 25px;
      cursor: pointer;
    }
  }
  .cp_tree-table_row{
    border-bottom: 2px solid rgb(55 53 46 / 8%);
  }
  .cp_tree-table_row:hover{
    background: #5b94e342;
  }
  .row{
    padding: 10px;
    span{
      padding-right: 10px;
    }
  }
  .viewselector{
    padding-left: 5px;
    padding-right: 5px;
    label{
      text-transform: capitalize;
      padding-left 10px;
    }
  }
  .data-cell{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .trackstatus{
    justify-content: center;
    border-bottom: 1px solid rgb(55 53 46 / 8%);
  }
  .badge{
    background-color: #5b94e3 !important;
  }
  h5 {
    display: inline;
  }
  .with-children-btn{
    display: none
  }
  .with-children:hover .with-children-btn {
    margin-left: 5px;
    display: inline;
  }
  .elipsis-link{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 160px;
  }
  .question-elipsis{
    justify-content: space-between;
    display: flex;
    align-items: center;
  }
  .elipsis-title{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 160px;
  }
  .title-elipsis{
    display: flex;
    align-items: center;
  }
`;

interface IScorePageProps {
  statusScore: IStatusScore;
  setCapability: Function;
  setQuestionId: Function;
  handleonClick: Function;
}

export const Score = (props: IScorePageProps) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [scoreData, setScoreData] = useState<any>([]);

  const nodes: any = {
    capability: {
      treeNodes: [{
        colName: `category`,
        width: '200px'
      }, {
        colName: `subCategory`,
        width: '200px'
      }, {
        colName: `capability`,
        width: '200px'
      }, {
        colName: `question`,
        width: '200px'
      }],
      dataNodes: [{
        colName: `score`,
        width: '50px'
      }, {
        colName: `probability`,
        width: '50px'
      }],
    }
  }
  useEffect(() => {
    if (props.statusScore) {
      let _scoreData = props.statusScore.capabilityViews.reduce((catAcc: any, currCat: ICapabilityViewSS) => {
        let catData = { data: {}, children: [] };
        catData.data = {
          categoryId: currCat.categoryId,
          categoryTitle: currCat.categoryTitle,
          ...currCat.categoryStatus
        }
        catData.children = currCat.subCategories.reduce((subCatAcc: any, currSubCategory: ISubCategorySS) => {
          let subCatData = { data: {}, children: [] }
          subCatData.data = {
            subCategoryId: currSubCategory.subCategoryId,
            subCategoryTitle: currSubCategory.subCategoryTitle,
            ...currSubCategory.subCategoryStatus
          }
          subCatData.children = currSubCategory.capabilities.reduce((capAcc: any, currCap: ICapabilitySS) => {
            let capData = { data: {}, children: [] }
            capData.data = {
              capabilityId: currCap.capabilityId,
              capabilityTitle: currCap.capabilityTitle,
              ...currCap.capabilityStatus
            }
            capData.children = currCap.questions.reduce((queAcc: any, currQuestion: IQuestionSS) => {
              let queData = { data: {} }
              queData.data = {
                questionId: currQuestion.questionId,
                questionTitle: currQuestion.title,
                score: currQuestion.score
              }
              queAcc.push(queData)
              return queAcc
            }, [])
            capAcc.push(capData)
            return capAcc
          }, [])
          subCatAcc.push(subCatData)
          return subCatAcc;
        }, [])
        catAcc.push(catData)
        return catAcc
      }, [])
      setScoreData(TreeState.create(_scoreData))
    }
  }, [props.statusScore]);



  const renderTreeCell = (row: any, dataName: string) => {

    return (
      <div
        className={row.metadata.hasChildren ? 'with-children' : 'without-children'}>
        {(row.data[`${dataName}Title`] && row.metadata.hasChildren)
          ? (
            <div className='title-elipsis'>
              <div className='title-elipsis'>
                <button className={`toggle-button ${row.$state.isExpanded ? 'open' : ''}`} onClick={row?.toggleChildren}></button>
                <div className='capitalize elipsis-title' title={camelize(row.data[`${dataName}Title`])}>
                  {camelize(row.data[`${dataName}Title`])} {row.data.count ? `(${row.data.count})` : ''}
                </div>
              </div>
              <div>
                <button className='with-children-btn' onClick={() => props.handleonClick(row.data[`${dataName}Title`], row, dataName, props.statusScore.capabilityViews)}>+</button>
              </div>
            </div>
          )
          : dataName === 'question' ?
            <div className='question-elipsis'>
              <div className='elipsis-link'>
                <a
                  onClick={(e) => handleNavigation(e, row, dataName)}
                  className={`${row.data[`${dataName}Title`] ? `${dataName}Title` : ''} data-cell`}
                  title={row.data[`${dataName}Title`]}>
                  {row.data[`${dataName}Title`]}
                </a>
              </div>
              <div>
                {
                  row.data[`${dataName}Title`] ? <button className='hover-capability' onClick={() => props.handleonClick(row.data[`${dataName}Title`], row, dataName, props.statusScore.capabilityViews)}>+</button> : ""
                }
              </div>
            </div>
            : <span title={camelize(row.data[`${dataName}`])} className='capitalize'>{camelize(row.data[`${dataName}`])}</span>
        }

        {(row.data.subCategoryTitle === '' && !row.$state.isExpanded) && (row.toggleChildren())}
      </div>
    );
  }

  const renderDataCell = (row: RowModel, dataName: string) => {
    return (
      <span
        style={{ textAlignLast: typeof row.data[dataName] === 'string' ? 'left' : 'center' }}
        title={row.data[dataName]}
        className='data-cell'>
        {typeof row.data[dataName] === 'string' ? camelize(row.data[dataName]) : row.data[dataName]}
      </span>
    );
  }

  const handleNavigation = (e: any, row: RowModel, field: string) => {
    e.preventDefault();
    props.setCapability(row.data[`${field}Id`])
    if (field === 'questionTitle') {
      props.setQuestionId(row.data[`${field}Id`])
    }
    dispatch(saveCandidateLastActivity({
      selectedCapabilityId: row.data[`${field}Id`],
      currentQuestionId: field === 'questionTitle' ? row.data[`${field}Id`] : ''
    }))
    history.push('/question')
  }


  const handleTreeClick = (newValue: any) => setScoreData(newValue)

  return (
    <StyledContainer>
      <Row className='controls ml-0'>
        <TreeTable
          value={scoreData}
          height={160}
          headerHeight={38}
          onChange={handleTreeClick}>
          {nodes.capability.treeNodes.map((treeLevel: any) => <TreeTable.Column
            basis={treeLevel.width}
            key={treeLevel.colName}
            renderCell={(row: any) => renderTreeCell(row, treeLevel.colName)}
            renderHeaderCell={() => <span className='capitalize'>{treeLevel.colName}</span>} />)}

          {nodes.capability.dataNodes.map((statusLevel: any) => <TreeTable.Column
            key={statusLevel.colName}
            basis={statusLevel.width}
            renderCell={(row: any) => renderDataCell(row, statusLevel.colName)}
            renderHeaderCell={() => <span className='t-right capitalize'>{statusLevel.colName}</span>} />)}
        </TreeTable>
      </Row>
    </StyledContainer>
  );
};
